import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import flattenDeep from 'lodash/flattenDeep';
import createSelections from '@/utils/widget/createSelections';
export default function useSelectionLegends(_ref) {
  let {
    resultsUpdated,
    results,
    skipResultsCount = 0,
    legendsSelections,
    legendsSelectionConfig
  } = _ref;
  const legendsSelectionsResult = useMemo(() => {
    if (!legendsSelections || !legendsSelectionConfig) return [];
    const groups = flattenDeep(results.map(result => createSelections({
      result,
      selections: legendsSelections || '',
      selectionConfig: legendsSelectionConfig,
      labeled: false
    }))); // select every Nth data point for display in chart legends

    if (skipResultsCount > 0) {
      return groups.map(group => {
        return _objectSpread(_objectSpread({}, group), {}, {
          data: skipItems(group.data, skipResultsCount)
        });
      });
    }

    return groups; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legendsSelections, legendsSelectionConfig, skipResultsCount, resultsUpdated]);
  const selectionLegends = useMemo(() => {
    return flattenDeep((legendsSelectionsResult || []).map(selections => selections.data.filter(selection => Boolean(selection.value)) // ignore empty values
    .map(selection => `${selection.value}`)));
  }, [legendsSelectionsResult]);
  return {
    selectionLegends,
    legendsSelectionsResult
  };
} // Skip every Nth item in an array

function skipItems(data, skipCount) {
  return data.filter((_, index) => index % (skipCount + 1) === 0);
}